export default __webpack_public_path__ + "static/aurec-active-logo-677feeb90a70bfdb80e59740c52ce5ed.svg";